<template>
    <div>
        <div class="col-md-6">
            <label class="attribute-label m-bottom-12">Voucher Code</label>

            <div class="input-group width-100">

                <input type="text" :id="id" class="form-control price-new-inputs" :name="name" v-model="code"
                       :disabled="voucher">

                <span class="input-group-addon input-group-addon-new-design">
                <button class="btn validate-btn-background" v-if="!voucher" @click.prevent="validate"><span
                    class="apply-title">Apply</span></button>
                <button class="btn validate-btn-background" v-else @click.prevent="remove"><span class="apply-title">Remove</span></button>
            </span>
            </div>
        </div>

        <div class="col-md-6" v-if="voucher">
            <label class="attribute-label m-bottom-12">Voucher Discount</label>

            <div class="input-group width-100">
                <input type="text" id="voucher_discount" name="voucher_discount" :value="valueComputed" class="price-new-inputs form-control border-radius-8" disabled readonly>
            </div>
          <input type="hidden" id="voucher_id" :value="voucher.voucher_id" name="voucher_id" />
        </div>

    </div>
</template>

<script>

import {validateVoucher} from "@/modules/Services/api/billing";
import $ from 'jquery'
import {EventBus} from "@/events/event-bus";
import {getLocationData} from "@/events/sharedMethods.js";


require("notifyjs-browser/dist/notify")
$.notify.defaults({position: "left bottom"});

export default {
    name: "BookingVoucherField",
    props: ['value', 'subtotal', 'total', 'services','voucherValue'],
    data() {
        return {
            code: null,
            voucher: null,
            lat: $('#lat_1').val(),
            lon: $('#lon_1').val(),
        }
    },
    computed: {
        id() {
            return 'voucher_code'
        },
        name() {
            return 'voucher_code'
        },
        valueComputed() {
            if(!this.voucher)
                return 0;
            
            if (this.voucher.type === "AMOUNT")
                return this.voucher.value.toFixed(2)
            else if (this.voucher.type === "PERCENT")
                return this.total * (this.voucher.value / 100).toFixed(2)
            else if (this.voucher.type === "UNIT"){

                let reminder = this.voucher.value;
                let voucherValue = 0;

                for(let service of this.services){
                    
                    if(service.charge_by != "unit")
                        continue;
                    
                    let unitPrice = service.pricing.subtotal / service.pricing.quantity;

                    if(service.pricing.quantity == 1){
                        voucherValue += unitPrice
                        continue;
                    }
                    let difference = 0;
                    if(reminder == service.pricing.quantity){
                        difference = 0;
                    }else if(reminder >  service.pricing.quantity ){
                        difference = Math.max((reminder - service.pricing.quantity),0);
                    }else if(reminder <  service.pricing.quantity){
                        difference = reminder;
                    }


                    if(difference == 0)
                        voucherValue += unitPrice
                    else 
                        voucherValue += difference * unitPrice



                    reminder -= Math.max((service.pricing.quantity),0)
                }
                voucherValue = voucherValue.toFixed(2)
                this.$emit('input',voucherValue);
                return this.voucher.value;
            }
        }
    },
    methods: {
        // getLocationData,
        validate() {
            let customerId = $("#customer_id").val()
            let services = this.services.map((service, index) => {
                return {
                    'service_id': service.service_id,
                    'service_start_date': service.visits[0].startDate,
                    'service_start_time':service.visits[0].startTime,
                    'service_unit_count': service.pricing.quantity,
                    'service_price': service.pricing.subtotal,
                    'service_total_price': service.pricing.subTotalAfterDiscount,
                    'service_clone': service.clone,
                }
            })
            let data = {
                'code': this.code,
                'customer_id': customerId,
                'services': services,
                'subtotal': this.subtotal,
                'total': this.total,
                'lat': this.lat,
                'lon': this.lon,
            }
            validateVoucher(data).then(response => {
                if (response.data.validate) {
                    $.notify(response.data.message, "success")
                    this.voucher = response.data.data.voucher
                    // document.getElementById('voucher_id').value = response.data.data.voucher.voucher_id
                } else {
                    $.notify(response.data.message, "error")
                    this.voucher = null
                  // document.getElementById('voucher_id').value = null
                }
                this.$emit('input', this.voucher)
                EventBus.$emit('onVoucherAdded')
            })
        },
        remove() {
            this.voucher = null
          // document.getElementById('voucher_id').value = null
          this.code = null
            this.$emit('input', this.voucher)
            EventBus.$emit('onVoucherAdded')
        },
        addEventListeners(){
            this.$nextTick(() => {
            EventBus.$on('chenagedLocationAddress', () => {
                    const locationData = getLocationData(); // Invoke the function to get the data
                    this.lat = locationData[0].lat;
                    this.lon = locationData[0].lon;
                    if (this.value && locationData[0].lat && locationData[0].lon){
                        this.validate();
                    }
                });
            })
        }
    },
    mounted() {
        this.addEventListeners();
        if (this.value){
            this.voucher = this.value;
            this.code = this.value.code;
        }
    }
}
</script>

<style scoped>

</style>